import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Order } from '../../../models/order.model';
import { DateHelper } from '../../../helpers/date.helper';
import { ProductionPlanService } from '../../../services/production-plan.service';

@Component({
  standalone: false,
  selector: 'app-order-item',
  templateUrl: './order-item.component.html',
})

export class OrderItemComponent {
  @Input() order: Order;
  @Input() isOpen: boolean;
  @Input() isSelectable: boolean;
  @Input() viewOptionKey: string;
  @Input() sliceStart: number;
  @Input() sliceEnd: number;
  // @Input() selectedOperations: Array<Operation> = [];
  @Input() partialDeadlines: any;

  @Output() toggleOrder = new EventEmitter();
  @Output() readonly notifyAboutOperationDisplacement = new EventEmitter();


  selectedDay: any;

  isDeviationModalOpen: boolean;
  isDeadlineModalOpen: boolean;
  // isOperationsDisplacementModal: boolean;

  constructor(private dateHelper: DateHelper,
              private productionPlan: ProductionPlanService) {
  }

  onToggleOrder(order: Order): any {
    this.toggleOrder.emit(order);
  }

  onSelectOrder(): void {
    this.order.isSelected = !this.order.isSelected;
    // Select/Unselect all operations
    this.order.operations.map(operation => operation.isSelected = this.order.isSelected);
  }

  onOpenDeviationModal(): void {
    this.isDeviationModalOpen = true;
  }

  onIgnoreDeviation(event: boolean): void {
    if (event) {
      this.productionPlan.ignoreDeviation(this.order.id).subscribe(
        () => {
          this.order.deviationFromPlan = false;
          this.order.operations.map(operation => operation.deviationFromPlan = false);
        }
      )
    }
    this.isDeviationModalOpen = false;
  }

  onOpenDeadlineModal(day: any): void {
    this.isDeadlineModalOpen = true;
    this.selectedDay = day;
  }

  onCloseDeadlineModal(): void {
    this.isDeadlineModalOpen = false;
  }

  // onOpenOperationsDisplacementModal(): void {
  //   this.isOperationsDisplacementModal = true;
  // }

  // handleOperationsDisplacementModal(event: any): void {
  //   this.isOperationsDisplacementModal = false;
  // }

  trackByFn(index: number): number {
    return index;
  }
}
